import { createSlice } from '@reduxjs/toolkit';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { init_local_search_delete } from './local_search_delete';
import { init_local_search_set_current } from './local_search_set_current';
import { init_local_search_upsert } from './local_search_upsert';
import { init_remote_search_create } from './remote_search_create';
import { init_remote_search_update } from './remote_search_update';
import { StateSearch } from './state_search';
import { init_remote_search_token_add } from './tokens/remote_search_token_add';
import { init_remote_search_tokens_delete } from './tokens/remote_search_tokens_delete';
import { init_remote_search_tokens_update_visibility } from './tokens/remote_search_tokens_update_visibility';

const initialState: StateSearch = {
  search_current: DTOSearchSettings.CREATE_STUB(),
  search_history_map: new Map(),
};

export const slice_search = createSlice({
  name: ENUM__redux_slice.SEARCH,

  initialState,

  reducers: {
    upsert: init_local_search_upsert,
    delete: init_local_search_delete,
    set_current: init_local_search_set_current,
  },

  extraReducers: builder => {
    init_remote_search_create(builder);
    init_remote_search_update(builder);

    init_remote_search_token_add(builder);
    init_remote_search_tokens_delete(builder);
    init_remote_search_tokens_update_visibility(builder);

    builder.addCase(LOCAL__global_reset, state => {
      return initialState;
    });
  },
});
